import React from "react";

const TechnicalSkills = () => {
  return (
    <div id="technical-skills">
      <div className="technical-skills__header">Technical Skills</div>
      <div className="technical-skills__container">
        <ul className="technical-skills__list">
          <li className="technical-skills__item">
            <div className="technical-skills_item-category">
              Programming Languages:
            </div>

            <div className="technical-skills_item-content">
              JavaScript, Typescript, Python, Java, C/C++
            </div>
          </li>
          <li className="technical-skills__item">
            <div className="technical-skills_item-category">
              Web Development:
            </div>

            <div className="technical-skills_item-content">
              React, Angular, Next, Typescript, JavaScript, HTML, CSS, SASS,
              Tailwind, Material UI, D3.js.
            </div>
          </li>
          <li className="technical-skills__item">
            <div className="technical-skills_item-category">
              Mobile Development:
            </div>
            <div className="technical-skills_item-content">
              Native Android, React-Native.
            </div>
          </li>
          <li className="technical-skills__item">
            <div className="technical-skills_item-category">
              Backend Development:
            </div>
            <div className="technical-skills_item-content">
              Node JS, Express, FastAPI
            </div>
          </li>
        </ul>
        <ul className="technical-skills__list">
          <li className="technical-skills__item">
            <div className="technical-skills_item-category">
              Database Management:{" "}
            </div>{" "}
            <div className="technical-skills_item-content">
              MongoDB, Firebase, MySQL, PostgreSQL, OpenSearch
            </div>
          </li>
          <li className="technical-skills__item">
            <div className="technical-skills_item-category">
              DevOps & Tools:
            </div>
            <div className="technical-skills_item-content">
              CI/CD (AWS, GitHub Actions, GitLab), Gerrit, Bitbucket, Docker,
              Kubernetes
            </div>
          </li>
          <li className="technical-skills__item">
            <div className="technical-skills_item-category">Agile & UX:</div>
            <div className="technical-skills_item-content">
              Scrum, User Experience: User research, UX design, Wireframing,
              Prototyping (Sketch, Invision, Marvel App, Figma, Adobe XD)
            </div>
          </li>
          <li className="technical-skills__item">
            <div className="technical-skills_item-category">
              AI Technologies:
            </div>
            <div className="technical-skills_item-content">
              Claude, Copilot, Cursor, N8N, LangFlow
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TechnicalSkills;
